<template>
  <right-menu-item
    v-if="show"
    @click.prevent="click"
    :class="{ 'muted': !isActive }"
    :text="$t('Delete')"
    :loading="loading"
    icon="trash"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcDocumentStore from '@/frontapp/store/bcDocument'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import { showConfirm } from "../BcConfirm";
import { trackEvent } from '../../gtm'

export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    show () {
      return this.bcDocumentStore.document.can_edit && this.bcDocumentStore.edit
    },
    isActive() {
      if (this.bcSelectedStore.listFullySelected.length === 0) {
        return false
      }

      // first page is not selected
      return !this.bcSelectedStore.isFullySelected(this.bcDocumentStore.document.children[0])
    },
    ...mapStores(useBcDocumentStore, useBcSelectedStore)
  },
  methods: {
    async click() {
      const realyDelete = await showConfirm({
        header: this.$t('Do you realy want to delete selected items?'),
      })
      
      if (!realyDelete) {
        return
      }

      this.loading = true
      const elements = [].concat(this.bcSelectedStore.listFullySelected)
      this.bcDocumentStore.deleteElementsRecursive(elements.map((item) => { return item.id }))
      this.bcSelectedStore.reload()
      await this.bcDocumentStore.deleteElements(elements, async (documentRev, resolve) => {
        if (documentRev.id !== this.bcDocumentStore.documentRev) {
          // have to reload document
          this.bcDocumentStore.willChangeRevision = true
          await this.$router.replace({ 
            name: 'BCDocumentDetailRev',
            params: { revId: documentRev.id } 
          })
        }

        resolve()
      })
      this.loading = false
      trackEvent(this.$route.matched[0].name, 'deleteElement')
    }
  },
}
</script>

<style lang="scss" scoped></style>
